<template>
  <div>
    <div :id="chunrk?'header-chunrk':'header'" :class="isFixed?'ss':'header-chunrk-class'">
      <div class="content overflow">
        <div class="left">
          <router-link :to="{path:'/home'}">
            <img v-show=" chunrk==false" src="@/assets/image/logo-top.png" alt="">
            <img v-show="chunrk==true" src="@/assets/image/logo-top-chunrk.png" alt="">
          </router-link>
        </div>
        <ul v-if="isNav" class="center right">
          <li :class="active==5?'item left active':'item left'">
            <div class="title">
              <router-link v-bind:to="'contact'">联系我们</router-link>
            </div>
            <div v-if="active==5" class="icon"></div>
          </li>
          <li :class="active==4?'item left active':'item left'">
            <div class="title">
              <router-link v-bind:to="'develop'">职业发展</router-link>
            </div>
            <div v-if="active==4" class="icon"></div>
          </li>
          <li :class="active==3?'item left active':'item left'">
            <div class="title">
              <router-link v-bind:to="'product'">产品服务</router-link>
            </div>
            <div v-if="active==3" class="icon"></div>
          </li>
          <li :class="active==2?'item left active':'item left'">
            <div class="title">
              <router-link v-bind:to="'about'">了解我们</router-link>
            </div>
            <div v-if="active==2" class="icon"></div>
          </li>
          <li :class="active==1?'item left active':'item left'">
            <div class="title">
              <router-link v-bind:to="'home'">首页</router-link>
            </div>
            <div v-if="active==1" class="icon"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import setting from '@/settings.js'

export default {
  props: {
    isactive: {
      default: '1'
    },
    ischunrk: {
      default: false
    },
    isnav: {
      default: true
    },
    issite: {
      default: false
    },
    isfixed: {
      default: true
    }
  },
  // computed: {
  //   fixedComputed() {
  //     let sty = {}
  //     if (this.isFixed) {
  //       // sty = { "position": "fixed" }
  //     } else {
  //       sty = {}
  //     }
  //     return sty
  //   }
  // },
  data() {
    return {
      active: this.isactive,
      isChunrk: this.ischunrk,
      isNav: this.isnav,
      chunrk: false,
      isSite: this.issite,
      isFixed: this.isfixed,
      isShow: false
    }
  },
  mounted() {
    // window.console.log(this.initScroll())
    this.isLogin = setting.global
    const _this = this
    if (_this.isChunrk) {
      _this.chunrk = true
    } else {
      window.addEventListener('scroll', function () {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        if (scrollTop > 60) {
          _this.chunrk = true
        } else {
          _this.chunrk = false
        }
      })
    }
  },
}
</script>
<style lang='scss' scoped>
$height: 36px;
$opacity: 0.8;
$color: #40A9FF;

ul,
li {
  list-style: none;
}

/deep/ #customPhoto {
  &:hover #customList {
    display: block;
  }

  img {
    margin-left: 15px;
  }

  #customList {
    display: none;
    position: absolute;
    width: 90px;
    top: 45px;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;

    .custom-item {
      cursor: pointer;
      background: #ffffff;
      padding: 10px;
      color: #000000;
      line-height: 24px;
      border-radius: 4px;

      &:hover {
        color: #13c2c2;
      }
    }
  }
}


img {
  height: 100%;
  width: 100%;
  border: none;
}

.left {
  float: left;
}

.right {
  float: right;
}

.overflow {
  overflow: hidden;
}

/deep/ #handleCommand {
  /deep/ li:hove {
    color: #13c2c2;
  }
}

/*正常的未被访问过的链接*/
/deep/ a:link {
  text-decoration: none;
}

/*已经访问过的链接*/
/deep/ a:visited {
  text-decoration: none;
}

/*鼠标划过(停留)的链接*/
/deep/ a:hover {
  text-decoration: none;
}

/* 正在点击的链接*/
/deep/ a:active {
  text-decoration: none;
}

#header,
#header-chunrk {
  font-family: PingFangSC-Regular, PingFan;
  font-size: 14px;
  height: 60px;
  width: 100%;
  position: fixed;
  color: #FFFFFF;
  z-index: 999;

  .item {
    cursor: pointer;

    .title {
      a {
        text-decoration: none;
        color: #FFFFFF;
      }


    }
  }

  .content {
    height: $height;
    width: 1200px;
    padding: 10px 0px;
    margin: 0 auto;

    .left {
      height: $height;
      width: 106px;
      height: 34px;

      /* img {
        width: 106px;
        height: 34px;
      } */
    }

    .center {
      width: 352px;
      height: $height;
      margin: 0 auto;

      .item {
        width: 88px;
        line-height: 38px;
        height: $height;
        text-align: center;
        opacity: $opacity;

        &:hover {
          opacity: 1;
        }
      }

      .icon {
        opacity: 0.65;
        height: 2px;
        width: 24px;
        margin: 0 auto;
        border-bottom: 2px solid #ffffff;
      }
    }

    .right {
      width: 440px;
      height: $height;
      text-align: center;

      .go_home {
        float: left;
        margin-top: 10px;

        a {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      .item {
        height: 32px;
        width: 88px;
        line-height: 32px;
        margin-top: 5px;
        float: right;
        opacity: $opacity;

        &:hover {
          opacity: 1;
        }
      }

      .active {
        opacity: 1;
      }

      .logon {
        height: 30px;
        line-height: 30px;
        border: 1px solid #ffffff;
        border-radius: 4px;
      }
    }
  }
}

#header-chunrk {
  background: #ffffff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.10);
  color: rgba(0, 0, 0, 0.65);

  .item {
    .title {
      a {
        color: rgba(0, 0, 0, 0.65);
      }
    }

    &:hover a {
      color: $color;
    }
  }

  .content {
    .center {
      .active {
        opacity: 1;

        a {
          color: $color;
        }


        .icon {
          border-bottom: 2px solid $color;
        }
      }
    }

    .right {
      .item {
        color: $color;
      }

      .logon {
        border-color: $color;
        background: $color;
        color: #ffffff;
      }
    }
  }
}
</style>
